import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';
import { minLength, required, numeric, requiredIf } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

var PHONE_INPUT_SEPARATOR = ' ';
/**
 * The phone number input is a input that combines both the calling code
 * prefix and the phone number itself into two fields.
 */
var PhoneNumberComponent = /** @class */ (function (_super) {
    __extends(PhoneNumberComponent, _super);
    function PhoneNumberComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prefix = '';
        _this.number = '';
        return _this;
    }
    PhoneNumberComponent.prototype.created = function () {
        if (this.value) {
            this.formBuilderChange();
        }
    };
    Object.defineProperty(PhoneNumberComponent.prototype, "phonePlaceholder", {
        get: function () {
            if (!this.placeholder) {
                return (this.$t('phone-number.number.placeholder') ||
                    this.$t('sign-up-step-two.mobile.placeholder'));
            }
            return this.placeholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhoneNumberComponent.prototype, "phoneRegex", {
        get: function () {
            return new RegExp(this.phoneValidator);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhoneNumberComponent.prototype, "phoneErrorMessage", {
        get: function () {
            if (this.prefix === '+1') {
                return this.$t('phone-number.error.message.us');
            }
            else if (this.showErrorMessages) {
                return this.$t('phone-number.error.message');
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhoneNumberComponent.prototype, "phonePrefixes", {
        get: function () {
            if (!this.prefixes) {
                return [];
            }
            var prefixArray = this.prefixes.split(',');
            return prefixArray.map(function (prefix) {
                var trimmedPrefix = prefix.trim();
                return {
                    name: trimmedPrefix,
                    value: trimmedPrefix,
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Emitted whenever the phone number inputs change or are
     * blurred.
     */
    PhoneNumberComponent.prototype.onChange = function () {
        this.formBuilderChange();
        var prefix = this.$v.prefix.$invalid ? '' : this.prefix;
        var number = this.$v.number.$invalid ? '' : this.number;
        return [prefix, number].join(PHONE_INPUT_SEPARATOR);
    };
    /**
     * Emits a stand alone change event which is used in form builder
     * The emitted value contains the value and the validity state
     */
    PhoneNumberComponent.prototype.formBuilderChange = function () {
        var value = [this.prefix, this.number].join(PHONE_INPUT_SEPARATOR);
        var isValid = !this.$v.prefix.$invalid && !this.$v.number.$invalid;
        return {
            value: value,
            isValid: isValid,
        };
    };
    /**
     * Watches the value prop for changes and updates the internal state accordingly
     * Splits the value into prefix and number based on the separator
     * Sets the prefix and number only if they are different from the current state
     * @returns {void}
     */
    PhoneNumberComponent.prototype.onValueChange = function () {
        if (!this.value) {
            return;
        }
        var _a = this.value.split(PHONE_INPUT_SEPARATOR), _b = _a[0], prefix = _b === void 0 ? '' : _b, _c = _a[1], number = _c === void 0 ? '' : _c;
        if (prefix !== this.prefix && !!prefix) {
            this.prefix = prefix;
        }
        if (number !== this.number && !!number) {
            this.number = number;
        }
    };
    PhoneNumberComponent.prototype.hasErrorBorder = function (field) {
        var form = this.$v[field];
        if (this.$attrs['has-error'] && form.$invalid) {
            return true;
        }
        return form.$dirty && (form.$error || form.$invalid);
    };
    PhoneNumberComponent.prototype.preventNonDigits = function (event) {
        if (event.data && !/^\d$/.test(event.data)) {
            event.preventDefault();
        }
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], PhoneNumberComponent.prototype, "optional", void 0);
    __decorate([
        Prop({
            type: String,
            default: "\\d{4,}",
        }),
        __metadata("design:type", String)
    ], PhoneNumberComponent.prototype, "phoneValidator", void 0);
    __decorate([
        Prop({ type: String, default: PHONE_INPUT_SEPARATOR }),
        __metadata("design:type", String)
    ], PhoneNumberComponent.prototype, "value", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PhoneNumberComponent.prototype, "prefixes", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PhoneNumberComponent.prototype, "placeholder", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], PhoneNumberComponent.prototype, "showErrorMessages", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], PhoneNumberComponent.prototype, "isPrefixDisabled", void 0);
    __decorate([
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PhoneNumberComponent.prototype, "onChange", null);
    __decorate([
        Emit('stand-alone-change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PhoneNumberComponent.prototype, "formBuilderChange", null);
    __decorate([
        Watch('value', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PhoneNumberComponent.prototype, "onValueChange", null);
    PhoneNumberComponent = __decorate([
        Component({
            name: 'ui-phone-number',
            inheritAttrs: false,
            validations: function () {
                var _this = this;
                if (!this.optional) {
                    return {
                        prefix: {
                            minLength: minLength(1),
                            required: required,
                        },
                        number: {
                            isValidPhone: function (value) {
                                return _this.phoneRegex.test("" + value);
                            },
                            required: required,
                            numeric: numeric,
                        },
                    };
                }
                return {
                    prefix: {
                        minLength: minLength(1),
                        required: requiredIf(function (form) {
                            return !!form.number;
                        }),
                    },
                    number: {
                        isValidPhone: this.optional && this.number
                            ? function (value) { return _this.phoneRegex.test("" + value); }
                            : function () { return true; },
                        numeric: numeric,
                        required: requiredIf(function (form) {
                            return !!form.prefix;
                        }),
                    },
                };
            },
        })
    ], PhoneNumberComponent);
    return PhoneNumberComponent;
}(Mixins(MagicConfigMixin, validationMixin)));

export default PhoneNumberComponent;
